import React from 'react';
import { Row, Col, Card, CardTitle, CardBody, FormGroup, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';

const ERPConnection = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (form) => {
    // TODO: not yet implemented — this Settings form's Save is currently a no-op.
    console.log('### form ###', form);
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
        <Row>
          <Col sm="6">
            <Card>
              <CardBody>
                <CardTitle>ERP Authentication</CardTitle>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="username">Username</label>
                  </Col>
                  <Col md="4">
                    <input {...register('username')} type="text" className="form-control" placeholder="username" />
                  </Col>
                  <Col md="2">
                    <label htmlFor="password">Password</label>
                  </Col>
                  <Col md="4">
                    <input {...register('password')} type="password" className="form-control" placeholder="password" />
                  </Col>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
          <Col sm="6">
            <Card>
              <CardBody>
                <CardTitle>ERP Database Connection</CardTitle>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="db.provider">Provider</label>
                  </Col>
                  <Col md="8">
                    <select {...register('db.provider')} className="form-control">
                      <option value="mysql">Mysql</option>
                      <option value="postgres">Postgres</option>
                      <option value="oracle">Oracle</option>
                      <option value="db2">IBM DB2</option>
                    </select>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="db.host">Host</label>
                  </Col>
                  <Col md="8">
                    <input {...register('db.host')} type="password" className="form-control" placeholder="127.0.0.1" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="db.port">Port</label>
                  </Col>
                  <Col md="8">
                    <input {...register('db.port')} type="text" className="form-control" placeholder="3306" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="db.username">Username</label>
                  </Col>
                  <Col md="8">
                    <input {...register('db.username')} type="text" className="form-control" placeholder="username" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="db.password">Password</label>
                  </Col>
                  <Col md="8">
                    <input {...register('db.password')} type="password" className="form-control" placeholder="password" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="12">
                    <label htmlFor="db.port">Database & Schema</label>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="db.database">Database</label>
                  </Col>
                  <Col md="10">
                    <select {...register('db.database')} className="form-control">
                      <option value="samltd">SAMLTD</option>
                      <option value="saminc">SAMINC</option>
                    </select>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="2">
                    <label htmlFor="db.schema">Schema</label>
                  </Col>
                  <Col md="10">
                    <input {...register('db.schema')} type="text" className="form-control" placeholder="Schema" />
                  </Col>
                </FormGroup>
                <div className="float-end">
                  <Button type="submit" color="primary">
                    Save
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default ERPConnection;
